
<header class="header"  >
  <div class="skip-to-main-content text-center">
    <button tabindex="0" (click)="skipToMainContent()" class="skip-to-main-content-link">{{ "verbiage.banner.skipToMainContent.title" | transloco }}</button>
  </div>  
  <app-header></app-header>
</header>
<main class="page-container" role="main">
  <router-outlet></router-outlet>
</main>
<footer class="footer">
  <app-footer></app-footer>
</footer>